import Button from "@mui/material/Button";
import { useNitroStore } from "../../store/Store";

const InvalidProductPopup = () => {
  const [
    selectedLocation,
    product,
    showInvalidProductPopup,
    setShowInvalidProductPopup,
    openInsightsPanel,
    setShowCompetitiveAnalysisModal,
    setShowIndicationHistoryPanel,
  ] = useNitroStore((state) => [
    state.selectedLocation,
    state.product,
    state.showInvalidProductPopup,
    state.setShowInvalidProductPopup,
    state.openInsightsPanel,
    state.setShowCompetitiveAnalysisModal,
    state.setShowIndicationHistoryPanel,
  ]);

  const addProduct = () => {
    if (!selectedLocation) return;
    setShowCompetitiveAnalysisModal(true);
    setShowIndicationHistoryPanel(false);

    openInsightsPanel(selectedLocation.id, "Occupants", true);

    setShowInvalidProductPopup(false);
  };

  const cancel = () => {
    setShowInvalidProductPopup(false);
  };

  if (!showInvalidProductPopup) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 100,
        fontSize: 100,
        backgroundColor: "rgba(15, 44, 82, 0.5)", // Selecting pin location
      }}
    >
      <div
        style={{
          width: 360,
          height: 300,
          backgroundColor: "white",
          borderRadius: 9,
          borderColor: "#09B0F2",
          borderStyle: "solid",
          borderWidth: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            height: 60,
            minHeight: 60,
            borderTopLeftRadius: 6,
            borderTopRightRadius: 6,
            backgroundColor: "#09B0F2",
            color: "white",
            display: "flex",
            alignItems: "center",
            paddingLeft: 20,
            fontSize: 20,
            fontWeight: 700,
          }}
        >
          Invalid Product
        </div>

        {/* BODY */}
        <div
          style={{
            height: "100%",
            padding: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flexGrow: 1,
            gap: 15,
          }}
        >
          <div
            style={{
              color: "black",
              textAlign: "center",
              fontSize: 18,
              fontWeight: 700,
            }}
          >
            {`${selectedLocation?.name} does not include ${product}`}
          </div>

          <div
            style={{
              color: "#878787",
              textAlign: "center",
              fontSize: 16,
              fontWeight: 400,
            }}
          >
            Do you want to edit this location to add the product?
          </div>
        </div>

        {/* FOOTER */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 10,
            paddingBottom: 30,
          }}
        >
          <Button
            id="invalidProductPopupNoButton"
            variant="outlined"
            onClick={cancel}
          >
            NO
          </Button>
          <Button
            id="invalidProductPopupYesButton"
            variant="contained"
            color="primary"
            onClick={addProduct}
          >
            YES
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InvalidProductPopup;
